import React from "react";
import { FormattedMessage } from "react-intl";
import loyaltyCapabilities from "@Src_main/config/loyalty";
var ExternalLegalLink = _ref => {
  var {
    href,
    children
  } = _ref;
  return /*#__PURE__*/React.createElement("a", {
    href: href,
    target: "_blank",
    rel: "noopener noreferrer"
  }, children);
};
var LoyaltyLegalLinks = _ref2 => {
  var {
    consent = false
  } = _ref2;
  var {
    legal
  } = loyaltyCapabilities;
  if (!legal.ready) {
    return null;
  }
  var values = {
    termsLink: chunks => /*#__PURE__*/React.createElement(ExternalLegalLink, {
      href: legal.termsUrl
    }, chunks),
    privacyLink: chunks => /*#__PURE__*/React.createElement(ExternalLegalLink, {
      href: legal.privacyUrl
    }, chunks)
  };
  return /*#__PURE__*/React.createElement(FormattedMessage, {
    id: consent ? "loyalty.legal.consent" : "loyalty.legal.links",
    values: values
  });
};
export default LoyaltyLegalLinks;